// Only the account-creation action can request an automatic checkout handoff.
// Keep it in memory so reloading, signing in later, or reopening an old URL
// shows the saved-plan screen instead of starting another redirect.
let newlyCreatedUserId: string | null = null;

export function markNewSignupHandoff(uid: string) {
  newlyCreatedUserId = uid;
}

export function consumeNewSignupHandoff(uid: string): boolean {
  if (newlyCreatedUserId !== uid) return false;
  newlyCreatedUserId = null;
  return true;
}
